import { useEffect, useRef, useState } from 'react';
import { useThrottle, useWindowScroll } from 'react-use';

const MIN_DELTA = 2;

const useScrollDirection = () => {
  const scroll = useWindowScroll();
  const throttledScroll = useThrottle(scroll, 300);
  const previous = useRef({
    y: window.pageYOffset,
    scrollDirection: 'DOWN',
  });
  const [position, setPosition] = useState(() => ({
    y: throttledScroll.y,
    scrollDirection: previous.current.scrollDirection,
    previousScrollDirection: previous.current.scrollDirection,
  }));

  useEffect(() => {
    const delta = throttledScroll.y - previous.current.y;
    const scrollDirection =
      delta > MIN_DELTA
        ? 'DOWN'
        : delta < -MIN_DELTA
          ? 'UP'
          : previous.current.scrollDirection;
    const nextPosition = {
      y: throttledScroll.y,
      scrollDirection,
      previousScrollDirection: previous.current.scrollDirection,
    };
    previous.current = {
      y: throttledScroll.y,
      scrollDirection,
    };
    setPosition(nextPosition);
  }, [throttledScroll.y]);

  return position;
};

export default useScrollDirection;
